// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7db04747","455":"0882f7a0","977":"0bbdeb86"}[chunkId] + ".chunk.js";
};